import axios from "axios";
import Adviser from "@/shared/apis/adviser";
import Admin from "@/shared/apis/admin";
import RegistrationApproval from "@/shared/apis/registrationApproval";
import ApplicationStatistics from "@/shared/apis/applications"
import Annoucement from "@/shared/apis/annoucement";
import LoginUtil from "../login/LoginUtil";
import { installResponseInterceptor } from "@/shared/apis/sessionAuth";
import Applicants from "@/shared/apis/applicants";
import Hostel from "@/shared/apis/hostel";
import Schools from "@/shared/apis/schools";
import Auth from "@/shared/apis/auth";
import Passkey from "@/shared/apis/passkey";
import MagicLink from "@/shared/apis/magicLink";
import ProgrammeChange from "@/shared/apis/programmeChange";
import Requirements from "@/shared/apis/requirements";
import Downloads from "@/shared/apis/downloads";
import Results from "@/shared/apis/results";
import ResultApprovals from "@/shared/apis/resultApprovals";
import ProgrammeAccreditations from "@/shared/apis/programmeAccreditations";
import Course from "@/shared/apis/course";
import Students from "@/shared/apis/students";
import Session from "@/shared/apis/session";
import ProgrammeType from "@/shared/apis/programmeType";
import Programmes from "@/shared/apis/programmes";
import Department from "@/shared/apis/department";
import Lecturer from "@/shared/apis/lecturer";
import Nationality from "@/shared/apis/nationality";
import Admission from "@/shared/apis/admission";
import ProgrammeDocuments from "@/shared/apis/programmeDocuments";
import ApplicantDocumentReviews from "@/shared/apis/applicantDocumentReviews";
import ProgrammeSettings from "@/shared/apis/programmeSettings";
import ProgrammeUtme from "@/shared/apis/programmeUtme";
import Transcript from "@/shared/apis/transcript";
import Semester from "@/shared/apis/semester";
import BasicInformation from "@/shared/apis/basicInformation";
import Global from "@/shared/apis/global";
import Signature from "@/shared/apis/signature";
import ProfilePicture from "@/shared/apis/profilePicture";
import Biometric from "@/shared/apis/biometric";
import StudentInformation from "@/shared/apis/studentInformation";
import SchoolFees from "@/shared/apis/schoolFees";
import User from "@/shared/apis/user";
import System from "@/shared/apis/system";
import Faculty from "@/shared/apis/faculty";
import PaymentPlatforms from "@/shared/apis/paymentPlatforms";
import SplitAccounts from "@/shared/apis/SplitAccounts";
import AuditTrail from "@/shared/apis/audittrail";
import Hospital from "@/shared/apis/hospital";
import Honour from "@/shared/apis/honour";
import DefaultDocument from "@/shared/apis/defaultDocument";
import Awards from "@/shared/apis/awards"
import Illness from "@/shared/apis/illness";
import ProgrammeLevel from "@/shared/apis/programmelevel";
import DataCorrection from "@/shared/apis/dataCorrection";
import ScratchCard from "@/shared/apis/scratchCard";
import ScreeningReason from "@/shared/apis/screeningReason";
import UtmeCombination from "@/shared/apis/utmeCombination";
import External from "@/shared/apis/external";
import StudentProgressStatus from "@/shared/apis/studentProgressStatus";
import Payments from "@/shared/apis/payments";
import PortalDocument from "@/shared/apis/portalDocument";
import StudentProgress from "@/shared/apis/studentProgress";
import Faker from "@/shared/apis/faker";
import Support from "@/shared/apis/support";
import SSCECombination from "@/shared/apis/ssceCombination";
import DepartmentUtme from "@/shared/apis/departmentUtme";
import Question from "@/shared/apis/question";
import Verification from "shared/apis/verification";
import Clearance from "@/shared/apis/clearance";
import CourseRegistrations from "@/shared/apis/courseRegistrations";
import Notification from "shared/apis/notification";
import Timetable from "@/shared/apis/timetable";
import ResultHistory from "@/shared/apis/resultHistory";
import ExternalExaminers from "@/shared/apis/externalExaminers";
import InternalExaminers from "@/shared/apis/internalExaminers";
import Reviewers from "@/shared/apis/reviewers";
import Supervisors from "@/shared/apis/supervisors";
import AdmissionQuota from "@/shared/apis/admissionQuota";
import GraduationConfig from "@/shared/apis/graduationConfig";
import Curriculum from "@/shared/apis/curriculum";
import WaiveReason from "@/shared/apis/waiveReason";
import Wallet from "@/shared/apis/wallet";
import CbtCourse from "@/shared/apis/cbtCourse";
import Convocation from "@/shared/apis/convocation";
import MatricHistory from "@/shared/apis/matricHistory";
import ResultAudit from "@/shared/apis/resultAudit";
import Defenses from "@/shared/apis/defenses";
import StatementDashboard from "@/shared/apis/statementDashboard";
import EAffidavit from "@/shared/apis/eaffidavit";
import StandalonePaymentManagement from "@/shared/apis/standalonePaymentManagement";
import ProgrammePathways from "@/shared/apis/programmePathways";


// for refresh token
Window.refreshingToken = false;

// timeout
axios.defaults.timeout = 1000 * 60 * 10; // 10 minutes


axios.interceptors.request.use(async function (config) {
    // Do something before request is sent
    let token = await LoginUtil.getAccessTokenAsync()
    if(token &&
        (config.url !== undefined &&
            !config.url.includes('authenticate') &&
            !config.url.includes('auth/passkey/sign-in/') &&
            !config.url.includes('bio-auth') &&
            !config.url.includes('refresh-token'))){
        config.headers.common['Authorization'] = `Bearer ${token}`
        config.withCredentials=!window.location.href.includes('localhost')
    }

    config.timeout = 10 * 60 * 1000; // 10 mins

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});


// response interceptors

// response interceptor: refresh on 401, otherwise end the session.
// See src/shared/apis/sessionAuth.js
installResponseInterceptor(axios);


/**
 * Collection of API hooks for the system
 */
const Api = {
    adviser: Adviser,

    admin: Admin,

    applications: ApplicationStatistics,

    admission: Admission,

    programmeDocuments: ProgrammeDocuments,

    applicantDocumentReviews: ApplicantDocumentReviews,

    annoucement: Annoucement,

    applicants: Applicants,

    auditTrails: AuditTrail,

    auth: Auth,

    passkey: Passkey,

    magicLink: MagicLink,

    awards: Awards,

    basicInformation: BasicInformation,

    biometric: Biometric,

    course: Course,

    dataCorrection: DataCorrection,

    defaultDocument: DefaultDocument,

    department: Department,

    downloads: Downloads,

    external: External,

    faculty: Faculty,

    global: Global,

    graduationConfig: GraduationConfig,

    honours: Honour,

    hospital: Hospital,

    hostel: Hostel,

    illness: Illness,

    lecturer: Lecturer,

    nationality: Nationality,

    payment: Payments,

    paymentPlatforms: PaymentPlatforms,

    studentProgressStatus: StudentProgressStatus,

    portalDocument: PortalDocument,

    programmes: Programmes,

    programmeChange: ProgrammeChange,

    programmeLevel: ProgrammeLevel,

    programmeType: ProgrammeType,

    profilePicture: ProfilePicture,

    programmeSettings: ProgrammeSettings,
    programmeUtme: ProgrammeUtme,

    registrationApproval: RegistrationApproval,

    requirements: Requirements,

    results: Results,

    resultApprovals: ResultApprovals,

    programmeAccreditations: ProgrammeAccreditations,

    scratchCard: ScratchCard,

    screeningReason: ScreeningReason,

    schools: Schools,

    schoolFees: SchoolFees,

    semester: Semester,

    session: Session,

    signature: Signature,

    splitAccounts: SplitAccounts,

    students: Students,

    studentInformation: StudentInformation,

    studentProgress: StudentProgress,

    system: System,

    support: Support,

    transcript: Transcript,

    utmeCombination: UtmeCombination,

    ssceCombination: SSCECombination,

    user: User,

    faker: Faker,

    departmentUtme: DepartmentUtme,

    question: Question,

    clearance: Clearance,

    verification: Verification,

    courseRegistrations: CourseRegistrations,

    notification: Notification,

    timetable: Timetable,

    resultHistory: ResultHistory,

    externalExaminers: ExternalExaminers,

    internalExaminers: InternalExaminers,

    reviewers: Reviewers,

    supervisors: Supervisors,

    admissionQuota: AdmissionQuota,

    curriculum: Curriculum,

    waiveReason: WaiveReason,

    wallet: Wallet,

    cbtCourse: CbtCourse,

    convocation: Convocation,

    matricHistory: MatricHistory,

    resultAudit: ResultAudit,

    defenses: Defenses,

    statementDashboard: StatementDashboard,

    eaffidavit: EAffidavit,

    standalonePaymentManagement: StandalonePaymentManagement,

    programmePathways: ProgrammePathways,
}


export default Api;
